import React from "react"
import { Container, Row, Col } from "reactstrap"

const Footer = () => {
  return (
    <React.Fragment>
      <footer className="footer" style={{left:'0px'}}>
        <Container fluid={true}>
          <Row>
            <Col md={6}>{new Date().getFullYear()} © Froth.</Col>
            <Col md={6}>
              <div className="text-sm-end d-sm-block">
                Powered by Robotico Digital
              </div>
            </Col>
          </Row>
        </Container>
      </footer>
    </React.Fragment>
  )
}

export default Footer
